<div class="p-3 container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card-body">
        <div class="flex items-center justify-between w-full">
          <div class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-500 shadow-sm overflow-x-auto" >
            <button *ngFor="let tab of proposalStatusTabs"
              class="flex items-center justify-start gap-2 px-2.5 py-2.5 rounded-xl text-xs font-bold transition-all duration-200 whitespace-nowrap min-w-fit outline-none"
                [ngClass]="activeStatusTabIndex.status === tab.status 
                ? 'bg-slate-800 text-white shadow-md ring-1 ring-slate-300' 
                : 'text-slate-700 hover:text-white hover:bg-slate-600/70'"
              (click)="onProposalStatusTabChange(tab)">
              
              <span class="w-2 h-4 rounded-2xl" 
                [ngClass]="{
                  'bg-gray-600': tab.status === 'form',
                  'bg-blue-700': tab.status === 'initiated',
                  'bg-amber-700': tab.status === 'in_review',
                  'bg-emerald-700': tab.status === 'approved',
                  'bg-slate-700': tab.status === 'short_close',
                  'bg-red-700': tab.status === 'rejected'
                }">
              </span>
          
              {{ tab.label }}
            </button>
          </div>
          </div>

        <!-- Tab Content -->
        <div class="tab-content" [class.active]="true">

          <!-- New Proposal Tab - Show Form -->
          <div *ngIf="activeStatusTabIndex.tab === 0" class="card proposal-card mt-3 shadow-sm border-0">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Create New Proposal</h5>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-warning px-4 py-2" (click)="tdfFrom?.submitForm()">Save Draft</button>
                <button type="button" class="btn btn-success px-4 py-2" *ngIf="tdfFrom?.tdfForm.valid" (click)="openDialog()"> Submit </button>
              </div>
            </div>

            <div class="card-body">
              <div *ngIf="draftProposals && draftProposals.length > 0" class="mb-3">
                
                <div class="alert alert-info" role="alert">
                  <div class="collapsible-section">
                    <div  (click)="isSectionOpen.draftProposals = !isSectionOpen.draftProposals">
                      
                        <i class="pi pi-info-circle me-1"></i>
                        <span>
                          <b>Draft Proposals Found:</b> Select a draft below to continue editing, or fill in the form to create a new proposal.
                        </span>
                        <i class="pi ms-2"
                           [ngClass]="isSectionOpen.draftProposals ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    
                    </div>
                    <div class="collapsible-body" *ngIf="isSectionOpen.draftProposals">
                      <app-data-table [data]="draftProposals"
                                      [title]="'Draft Proposals'"
                                      [url]="'/tdf/save-draft/proposal/'"
                                      [isEditable]="true"
                                      [showAddButton]="false"
                                      (editEventRow)="populateDraftProposal($event) ; isSectionOpen.draftProposals =false "
                                      [columns]="draftProposalColumns">
                      </app-data-table>
                    </div>
                  </div>
                </div>
              </div>
            
              <app-tdf-from #tdfFrom *ngIf="selectedDraftProposal" [proposalForm]="selectedDraftProposal" (submitFormEvent)="saveDraft($event)"  ></app-tdf-from>
              <app-tdf-from #tdfFrom *ngIf="!selectedDraftProposal"  (submitFormEvent)="saveDraft($event)" ></app-tdf-from>
            </div>
          </div>


          <!-- Single Table for All Tabs (except New Proposal) -->
          <div *ngIf="activeStatusTabIndex.tab === 1" class="card mt-3 shadow-sm border-0">
            <div class="card-header d-flex justify-content-between bg-primary text-white">
              <h4 class="card-title mb-0">{{proposalStatusTabs[activeStatusTabIndex.tab].label}}</h4>
              <div class="filter-section d-flex g-2 align-items-center">
                <div class="d-flex mx-3">
                  <!-- <p-button *ngIf="proposalStatusTabs[activeStatusTabIndex].status === 'initiated'" 
                    (click)="approveAPSO()" class="btn btn-success me-2 p-0">
                  </p-button> -->
                  <p-button label="Clear Filters" icon="pi pi-filter-slash" severity="success"
                    (click)="clear(dt, searchInput)" class="clear-filters-btn">
                  </p-button>
                </div>
                <div class="filter-right">
                  <span class=" p-input-icon-left ">
                    <i class="pi pi-search"></i>
                    <input #searchInput pInputText type="text" [(ngModel)]="searchProposalQuery"
                      (keyup.enter)="searchProposals(searchProposalQuery)" placeholder="Search across all records..."
                      class="search-field" />
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive p-3">
                <p-table #dt [value]="proposalData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[5, 10, 20, 50]" [paginator]="true" [lazy]="lazy" [totalRecords]="totalCount"
                  (onPage)="onPageChange($event)"
                  [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
                  [scrollable]="true" [(selection)]="selectedProposals" scrollDirection="both" [resizableColumns]="true"
                  [reorderableColumns]="true"
                  [globalFilterFields]="['name','description','proposal_status','created_by.first_name','created_by.last_name']"
                  dataKey="id" class="p-datatable-sm complex-proposal-table">

                  <ng-template pTemplate="header">
                    <tr>
                      <ng-container *ngFor="let column of tableColumns">
                        <th [pSortableColumn]=" column.field" pResizableColumn
                          class="sortable-column">
                          <!-- Column Header -->
                          <ng-container [ngSwitch]="column.field">
                            <ng-container *ngSwitchCase="'checkbox'">
                              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              <!-- <p-sortIcon styleClass="custom-sort-icon mx-2 text-white bg-white" [field]="column.field"></p-sortIcon> -->
                              <span>{{ column.header }}</span>
                            </ng-container>
                          </ng-container>

                          <!-- Column Filter -->
                          <p-columnFilter class="text-gray-600" *ngIf="column.filter" [type]="column.filterType" [field]="column.field"
                            display="menu" [showMatchModes]="true" [showOperator]="false"
                            [showAddButton]="false"></p-columnFilter>
                        </th>
                      </ng-container>
                    </tr>
                  </ng-template>

                  <!-- 🧩 Table Body -->
                  <ng-template pTemplate="body" let-proposal>
                    <tr [ngClass]="{ 'table-row-hover': true }">
                      <ng-container *ngFor="let column of tableColumns">
                        <td class="align-middle text-nowrap">
                          <ng-container [ngSwitch]="column.field">

                            <!-- ✅ Checkbox -->
                            <ng-container *ngSwitchCase="'checkbox'">
                              <p-tableCheckbox [value]="proposal" selectionMode="multiple"></p-tableCheckbox>
                            </ng-container>

                            <!-- ✅ Name -->
                            <ng-container *ngSwitchCase="'name'">
                              <span class="fw-semibold text-primary pointer" pTooltip="{{ proposal.name }}"
                                (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                {{ proposal.name }}
                              </span>
                            </ng-container>

                            <!-- ✅ Description -->
                            <ng-container *ngSwitchCase="'description'">
                              <span class="text-muted text-truncate d-inline-block" style="max-width: 250px;"
                                [pTooltip]="proposal.description">
                                {{ proposal.description }}
                              </span>
                            </ng-container>

                            <!-- ✅ Steps -->
                            <ng-container *ngSwitchCase="'steps'">
                              <span class="badge bg-info text-dark">
                                {{ proposal.step_summary?.completed_steps || 0 }}/{{ proposal.step_summary?.total_steps
                                || 0 }}
                              </span>
                            </ng-container>

                            <!-- ✅ Progress -->
                            <ng-container *ngSwitchCase="'progress'">
                              <div class="progress" style="height: 8px;">
                                <div class="progress-bar bg-success"
                                  [style.width.%]="proposal.step_summary?.completed_percentage || 0"></div>
                              </div>
                              <small class="text-muted">
                                {{ proposal.step_summary?.completed_percentage || 0 }}%
                              </small>
                            </ng-container>

                            <!-- ✅ Created By -->
                            <ng-container *ngSwitchCase="'created_by'">
                              <i class="pi pi-user text-secondary me-1"></i>
                              {{ proposal.created_by?.first_name }} {{ proposal.created_by?.last_name }}
                            </ng-container>

                            <!-- ✅ Directorate -->
                            <ng-container *ngSwitchCase="'directorate'">
                              <i class="pi pi-building text-secondary me-1"></i>
                              {{ proposal.created_by?.unit?.name }}
                            </ng-container>

                            <!-- ✅ Status -->
                            <ng-container *ngSwitchCase="'proposal_status'">
                              <span class="badge rounded-pill px-3 py-1"
                                [ngClass]="getStatusBadgeClass(proposal.proposal_status)">
                                {{ proposal.proposal_status | titlecase }}
                              </span>
                            </ng-container>

                            <!-- ✅ Actions -->
                            <ng-container *ngSwitchCase="'actions'">
                              <button pButton type="button" icon="pi pi-ellipsis-v"
                                class="p-button-rounded p-button-text action-btn" (click)="op.toggle($event)"></button>

                              <p-overlayPanel #op>
                                <div class="list-group small">
                                  <a class="list-group-item list-group-item-action pointer"
                                    (click)="updateProposal(proposal)">
                                    Edit
                                  </a>
                                  <a class="list-group-item list-group-item-action pointer text-danger"
                                    (click)="deleteProposal(proposal)">
                                    Delete
                                  </a>
                                  <a class="list-group-item list-group-item-action pointer"
                                    (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                    Go to Steps
                                  </a>
                                </div>
                              </p-overlayPanel>
                            </ng-container>

                            <!-- ✅ Default -->
                            <ng-container *ngSwitchDefault>
                              {{ getFieldValue(proposal, column.field) || '-' }}
                            </ng-container>

                          </ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-template>

                  <!-- 📉 Empty Message -->
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="tableColumns.length" class="text-center text-muted py-3">
                        <i class="pi pi-info-circle me-2"></i> No proposals found.
                      </td>
                    </tr>
                  </ng-template>

                </p-table>
              </div>
            </div>
          </div>


        </div>
        <!-- No Proposals -->
        <ng-template #noData>
          <div class="alert alert-info">No proposals available for this phase.</div>
        </ng-template>


        <!-- <div class="d-flex card justify-content-center mt-4">
          <p-paginator [rows]="itemsPerPage" [totalRecords]="proposalData.length" [first]="(currentPage-1)*itemsPerPage"
            (onPageChange)="onPageChange($event)">
          </p-paginator>
        </div> -->

        <!-- ✅ Old Tab Content - commented out as we're using proposal status tabs now -->
        <!-- <div class="card px-3 py-3">
        <div *ngFor="let tab of tabList; let tabIndex = index">
          <div *ngIf="activeTabIndex === tabIndex" class="row g-4">
            <div class="col-12 col-md-6 col-lg-4" *ngFor="let proposal of getPagedProposals()">
              <ng-container *ngTemplateOutlet="proposalCardTemplate; context: { $implicit: proposal }"></ng-container>
            </div>
          </div>
        </div>
        </div> -->


        <!-- Pagination -->
        <!-- <div class="d-flex card justify-content-center mt-4">
          <p-paginator [rows]="itemsPerPage" [totalRecords]="proposalData.length"
            [first]="(currentPage - 1) * itemsPerPage" (onPageChange)="onPageChange($event)">
          </p-paginator>
        </div> -->
      </div>
    </div>
  </div>
</div>

<ng-template #proposalCardTemplate let-proposal>
  <div class="card scheme-card h-100 p-3">
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
      <p-tag severity="info" [value]="proposal?.scheme?.name" class="mb-2 mb-sm-0"></p-tag>
      <div class="d-flex gap-3">
        <span (click)="deleteProposal(proposal)" class="btn btn-light" pTooltip="Delete Proposal" tooltipPosition="top"
          *ngIf="
            ('/master/proposal' | hasPermission : 'Delete') ||
            proposal.can_edit == true
          "><i class="pi pi-trash delete-red"></i></span>
        <span (click)="updateProposal(proposal)" class="btn btn-light" pTooltip="Edit Proposal" tooltipPosition="top"
          *ngIf="
            ('/master/proposal' | hasPermission : 'Edit') ||
            proposal.can_edit == true
          "><i class="pi pi-pencil"></i></span>
        <span (click)="navigateToSchemeTransaction(proposal, activePhaseId)" class="btn btn-light"
          pTooltip="Go to Steps" tooltipPosition="top" *ngIf="'/master/proposal' | hasPermission : 'View'"><i
            class="pi pi-arrow-right"></i></span>
      </div>
    </div>

    <div class="ms-1">
      <h5 class="fw-bold mb-1">{{ proposal?.name }}</h5>
      <p class="text-muted-card small mb-3 description-truncate" [pTooltip]="proposal.description"
        tooltipPosition="top">
        {{ proposal.description }}
      </p>
    </div>

    <div class="mt-auto">
      <div class="d-flex justify-content-between small text-muted-card ms-1 mb-1">
        <span>Step {{ proposal.step_summary.completed_steps || 0 }}/{{
          proposal.step_summary.total_steps || 0
          }}</span>
        <span>{{ proposal.step_summary.completed_percentage }}% Complete</span>
      </div>
      <div class="progress ms-1 mb-3">
        <div class="progress-bar bg-primary" role="progressbar"
          [style.width.%]="proposal.step_summary.completed_percentage" aria-valuemin="0" aria-valuemax="100"></div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="text-muted-card small">
          <i class="bi bi-clock me-1"></i> Created
          {{ proposal.created_on | date : "dd-MM-yyyy" }}
        </div>
        <p-tag [value]="proposal.proposal_status | uppercase" severity="success" rounded></p-tag>
      </div>

      <button class="btn btn-gradient w-100" (click)="navigateToScheme(proposal)">
        View Details
      </button>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isDeleteProposal">
  <p-dialog header="Delete Proposal" [modal]="true" [(visible)]="isDeleteProposal" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog">
      <span>Are you sure , you want to delete
        {{ selectedProposal.name }} proposal?</span>
      <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()">
      </p-button>
    </div>
  </p-dialog>
</ng-container>

<ng-container *ngIf="addProposalVisible">
  <p-dialog [maximizable]="true" [header]="getDialogHeader()" [modal]="true" [(visible)]="addProposalVisible"
    [style]="{ width: '70rem' }">
    <div class="mt-3">
      <div class="custom-stepper">
        <div *ngFor="let item of items; let i = index" class="step-item" [class.active]="i === activeIndex"
          (click)="setActiveIndex(i)">
          <div class="step-number">{{ i + 1 }}</div>
          <div class="step-label">{{ item.label }}</div>
          <div class="step-connector" *ngIf="i < items.length - 1"></div>
        </div>
      </div>

      <div class="mt-4 mb-4">
        <!-- Step 1 Content -->
        <div *ngIf="items[activeIndex]?.label === 'Add Proposal'">
          <form [formGroup]="proposalForm" class="mt-1">
            <div class="row">
              <div class="col-md-6">
                <label for="proposalName">Proposal Name <b class="text-warning">*</b></label>
                <input pInputText id="proposalName" pSize="large" formControlName="proposalName" autocomplete="off"
                  class="w-100" />
                <div *ngIf="
                    proposalForm.get('proposalName')?.invalid &&
                    proposalForm.get('proposalName')?.touched
                  " class="text-warning mb-3">
                  Proposal Name is required
                </div>
              </div>
              <div class="col-md-6">
                <label class="ps-2" for="scheme">Scheme <b class="text-warning">*</b></label>
                <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true"
                  filterBy="name" optionLabel="name" placeholder="Scheme" [style]="{ width: '100%' }"
                  [disabled]="true" optionValue="id">
                </p-dropdown>
                <div *ngIf="
                    proposalForm.get('scheme')?.invalid &&
                    proposalForm.get('scheme')?.touched
                  " class="text-warning mb-3">
                  Scheme selection is required
                </div>
              </div>
            </div>
            <div class="mb-4 ms-1 px-1 w-100 pt-3">
              <label for="over_label">Proposal Description <b class="text-warning">*</b></label>
              <textarea pInputTextarea id="over_label" rows="5" pSize="large" formControlName="description"
                autocomplete="off" class="w-100" maxlength="100"></textarea>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" (click)="onSubmit()" class="btn btn-primary"
                [disabled]="proposalForm.invalid || proposalForm.pristine">
                Submit
              </button>
            </div>
          </form>
        </div>
        <!-- Award of Contract -->
        <!-- Step 2: Mandatory steps from previous phases -->
        <div *ngIf="
            items[activeIndex]?.label === 'Mandatory steps from Previous Phases'
          ">
          <div class="card p-3">
            <div class="d-flex justify-content-between mb-3">
              <h5 class="mb-3">Mandatory Steps from Previous Phases</h5>
              <div class="d-flex justify-content-end">
                <button type="button" (click)="
                    navigateToSchemeTransaction(selectedProposal, tabList[0].id)
                  " class="btn btn-primary">
                  Fill Details
                </button>
              </div>
            </div>

            <ng-container *ngFor="let phase of transactionPhaseStages">
              <div class="border p-3 mb-4">
                <h6 class="mb-3">
                  <b>{{ phase.phase.name }}</b>
                </h6>

                <ng-container *ngFor="let stage of phase.stages; let i = index">
                  <!-- Only show non-skipped (mandatory) steps -->
                  <ng-container *ngIf="!stage.skipped">
                    <div class="row align-items-center mb-3">
                      <div class="col-auto">
                        <input class="form-check-input border-primary" type="checkbox" [id]="'stage' + i"
                          name="targetStage" [checked]="true" [disabled]="true" />
                      </div>
                      <div class="col">
                        <label class="form-check-label" [for]="'stage' + i">
                          <div class="d-flex flex-column">
                            <span class="fw-medium">{{ stage.name }}</span>
                          </div>
                        </label>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <div class="d-flex justify-content-end">
              <button type="button" (click)="next()" class="btn btn-primary">
                Proceed
              </button>
            </div>
          </div>
        </div>

        <!-- Step 2 Content -->
        <div *ngIf="
            items[activeIndex]?.label === 'Skip Stages' 
          ">
          <div class="card p-3 mt-4 skip-stage-container">
            <!-- Important Notice -->
            <div class="alert alert-warning mb-4">
              <i class="bi bi-exclamation-circle me-2"></i>
              <strong>Important</strong>
              <p class="mb-0 mt-1">
                Select steps to skip or proceed with all the steps shown below.
                Skipping steps will remove those from the Proposal. This action
                cannot be undone.
              </p>
            </div>

            <!-- Stage Selection -->
            <div class="mb-4">
              <div class="d-flex justify-content-between">
                <h6 class="mb-3">Select Target Step</h6>
                <h6 class="mb-3">
                  <span class="badge bg-primary px-3 py-2 fs-6">
                    Allocated: {{ completionSum || 0 }}%
                  </span>
                </h6>
              </div>
              <div class="stages-list">
                <div class="form-check mb-3" *ngFor="let stage of stages; let i = index">
                  <input class="form-check-input border-primary" type="checkbox" [id]="'stage' + i" name="targetStage"
                    [value]="stage.id" [(ngModel)]="stage.skipped" [disabled]="stage.id <= currentStage" />
                  <label class="form-check-label w-100" [for]="'stage' + i">
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="d-flex flex-column">
                        <span class="fw-medium">
                          {{ stage.name }} -
                          <p-tag [value]="'step - ' + stage.sequence" severity="secondary" rounded></p-tag>
                        </span>
                        <small class="text-muted-card">{{
                          stage.description
                          }}</small>
                      </div>

                      <div class="d-flex align-items-end gap-3" *ngIf="!stage.skipped">
                        <!-- Timeline Input -->
                        <div class="">
                          <label class="form-label mb-1 small text-muted">Timeline (weeks)</label>
                          <input type="number" class="form-control form-control-sm w-100px" min="1"
                            [(ngModel)]="stage.week_timeline" placeholder="e.g. 2" />
                        </div>

                        <!-- Completion % Input -->
                        <div class="w-120px">
                          <label class="form-label mb-1 small text-muted">Completion %</label>
                          <input type="number" class="form-control form-control-sm w-120px" min="0" max="100"
                            [(ngModel)]="stage.percentage" (ngModelChange)="onCompletionChange()"
                            placeholder="e.g. 20" />
                        </div>
                      </div>
                    </div>
                  </label>

                  <!-- Textarea for skipped reason -->
                  <div *ngIf="stage.skipped" class="mt-2">
                    <textarea class="form-control" rows="3" placeholder="Enter reason for skipping this stage..."
                      [(ngModel)]="stage.remark"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="completionSum > 100" class="text-danger mt-2">
              Total completion percentage cannot exceed 100%.
            </div>

            <div *ngIf="
                anyCompletionEntered && !allCompletionFilled && !canSubmit()
              " class="text-danger mt-2">
              Please fill all Completion % fields if entering any.
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end gap-2">
              <button class="btn btn-light" (click)="addProposalVisible = false">
                Cancel
              </button>
              <button class="btn btn-primary" (click)="confirmSkipStage(); next()" [disabled]="
                  !canSubmit() ||
                  completionSum != 100 ||
                  (anyCompletionEntered && !allCompletionFilled)
                ">
                <i class="bi bi-skip-forward me-1"></i>
                Proceed
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="items[activeIndex]?.label === 'Route Configuration'">
          <div class="p-3 mt-4">
            <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>Steps</label>
                  <p-dropdown [options]="filteredStagesList" formControlName="step" optionValue="id" optionLabel="name"
                    placeholder="Select a Step" class="w-100" (onChange)="onStepChange($event)" [filter]="true"
                    filterBy="name">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3" *ngIf="!this.routeForm.get('approved')?.value">
                  <label>Role</label>
                  <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name"
                    placeholder="Select a Role" class="w-100" (onChange)="onRoleChange($event)" [filter]="true"
                    filterBy="name">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3">
                  <label>Directorate</label>
                  <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
                    placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true"
                    filterBy="name" appendTo="body">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3">
                  <label>User</label>
                  <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="first_name"
                    placeholder="Select a User" class="w-100" (onChange)="onUserChange($event)" [filter]="true"
                    filterBy="first_name" appendTo="body">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3 flex-col" *ngIf="!this.routeForm.get('approved')?.value">
                  <label for="menuIcon">Sequence</label>
                  <input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
                    class="w-100" [disabled]="true" />
                </div>
                <div class="col-md-12 mb-3 d-flex justify-content-between">
                  <div class="mb-3 ad-user">
                    <p-checkbox formControlName="approved" binary="true" inputId="ad_user" class="custom-checkbox me-3"
                      (change)="onAllRolesSame(true)"></p-checkbox>
                    <label for="ad_user"><b>Select only if you want the same user to be Initiator,
                        Recommender, and Approver for this step.</b></label>
                  </div>
                  <div class="footer-btn mt-6">
                    <button pButton label="Submit" type="submit" class="fetch-data-btn"
                      [disabled]="routeForm.invalid"></button>
                  </div>
                </div>
              </div>
            </form>

            <!-- MAke it table here -->
            <div class="mt-4 mb-4">
              <ng-container *ngIf="RouteUserList?.length > 0">
                <app-data-table [columns]="userCols" [data]="RouteUserList" [title]="'User Mapping'"
                  [isDeletable]="true" (deleteEventRow)="deleteUser($event)" [showAddButton]="false"
                  [showSearch]="false"></app-data-table>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-container>

<ng-container *ngIf="displayDialogN">
  <app-scheme-wise-route-popup [displayDialog]="displayDialogN" (closeDialog)="displayDialogN = false" (onSubmit)="onNeedformSubmit($event)" ></app-scheme-wise-route-popup>
</ng-container>